import { HTMLAttributes, ReactNode } from "react";
import clsx from "clsx";

type Props = {
  children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

export default function PlayerMenuControlLabel({ className, children, ...props }: Props) {
  return (
    <div className={clsx("font-bold text-white/50 uppercase text-12", className)} {...props}>
      {children}
    </div>
  );
}
